import axiosTokenInstance from 'services/api/backoffice';
import { DETAIL_TRANSACTIONS_STP, DETAIL_TRANSACTIONS_STP_ERROR } from '_models/redux/types';

// Action function
export const detailSTPAction = (transactions_id) => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(
      `/api/reports/v2/transactions-details-stp/${transactions_id}`,
    );

    const { data, status } = response || {};

    dispatch({
      type: DETAIL_TRANSACTIONS_STP,
      response: data || {},
      status: status || {},
      method: 'get',
    });
  } catch (e) {
    dispatch({
      type: DETAIL_TRANSACTIONS_STP_ERROR,
      response: e || {},
    });
  }
};
